import axios from "axios";
import queryString from "query-string";
import ToastCustom from "shared/components/ToastCustom";
import authProvider from "../shared/AuthProvider";

// Set up default config for http requests here
const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "content-type": "application/json",
  },
  paramsSerializer: (params) => queryString.stringify(params),
});

axiosClient.interceptors.request.use(async (config) => {
  // Handle token here ...
  if (authProvider.getTokenFromLocalStorage()) {
    config.headers.Authorization =
      "Bearer " + authProvider.getTokenFromLocalStorage();
  }
  return config;
});

axiosClient.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      return response.data;
    }
    return response;
  },
  (error) => {
    if (error.response.status === 404) {
      ToastCustom.error(`404 Not found with ${error.response.data.path} `);
    }
    throw error;
  }
);
export default axiosClient;
